import axios from "axios";

const baseUrl = "https://www.healthasyst.com/api";

export async function getStaffData(param) {
  try {
    const response = await axios.post(`${baseUrl}/staffdata`, param);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error fetching staff data: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error fetching staff data:", error);
    throw error;
  }
}

export async function calculateIncreasePaymentCollection(param) {
  try {
    const response = await axios.post(`${baseUrl}/calculateIncreasePaymentCollection`, param);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error fetching staff data: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error fetching staff data:", error);
    throw error;
  }
}

export async function calculateReduction(param) {
  try {
    const response = await axios.post(`${baseUrl}/calculate-reduction`, param);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error fetching staff data: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error fetching staff data:", error);
    throw error;
  }
}

export async function calculateEnbSavings(param) {
  try {
    const response = await axios.post(`${baseUrl}/calculate-enb-savings`, param);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error fetching staff data: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error fetching staff data:", error);
    throw error;
  }
}

export async function getReduceCostGoingPaperless(param) {
  try {
    const response = await axios.post(`${baseUrl}/reduceCostGoingPaperless`, param);

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error fetching staff data: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error fetching staff data:", error);
    throw error;
  }
}
